(function(){
  'use strict';

  var KEY='pmy_post_purchase_attribution_v1';
  var TTL=14*24*60*60*1000;

  function clean(v){return String(v==null?'':v).trim()}
  function now(){return Date.now?Date.now():(new Date()).getTime()}

  function read(){
    try{
      var raw=localStorage.getItem(KEY);
      if(!raw)return null;
      var data=JSON.parse(raw);
      if(!data||!data.savedAt||now()-Number(data.savedAt)>TTL){
        localStorage.removeItem(KEY);
        return null;
      }
      return data
    }catch(e){return null}
  }

  function write(data){
    try{localStorage.setItem(KEY,JSON.stringify(data))}catch(e){}
  }

  function productHandle(){
    var m=location.pathname.match(/\/products\/([^\/?#]+)/i);
    return m?decodeURIComponent(m[1]):''
  }

  function capture(){
    var params;
    try{params=new URLSearchParams(location.search)}catch(e){return read()}
    var source=clean(params.get('pmy_source'));
    var parent=clean(params.get('pmy_parent_order'));
    var recommendation=clean(params.get('pmy_recommendation'));

    if(source!=='post_purchase'&&!parent)return read();

    if(!recommendation)recommendation=productHandle();

    var data={
      source:'post_purchase',
      parentOrder:parent,
      recommendation:recommendation,
      savedAt:now()
    };
    write(data);
    return data
  }

  function attributes(){
    var data=read();
    if(!data||data.source!=='post_purchase')return[];
    var rows=[{name:'PMY Booking Source',value:'post_purchase'}];
    if(data.parentOrder)rows.push({name:'PMY Parent Order',value:data.parentOrder});
    if(data.recommendation)rows.push({name:'PMY Recommendation',value:data.recommendation});
    return rows
  }

  function queryForRecommendation(parentOrder,productHandle){
    var q=new URLSearchParams();
    q.set('pmy_source','post_purchase');
    if(clean(parentOrder))q.set('pmy_parent_order',clean(parentOrder));
    if(clean(productHandle))q.set('pmy_recommendation',clean(productHandle));
    q.set('utm_source','pmy');
    q.set('utm_medium','email');
    q.set('utm_campaign','post_purchase_cross_sell');
    return q.toString()
  }

  capture();

  window.PMYPostPurchaseAttribution={
    capture:capture,
    get:read,
    getOrderAttributes:attributes,
    queryForRecommendation:queryForRecommendation,
    clear:function(){try{localStorage.removeItem(KEY)}catch(e){}}
  };
})();